import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12 7.15918C12.4142 7.15918 12.75 7.49497 12.75 7.90918V12.8183C12.75 13.2325 12.4142 13.5683 12 13.5683C11.5858 13.5683 11.25 13.2325 11.25 12.8183V7.90918C11.25 7.49497 11.5858 7.15918 12 7.15918ZM12 16.9909C12.4971 16.9909 12.9 16.588 12.9 16.0909C12.9 15.5939 12.4971 15.1909 12 15.1909C11.5029 15.1909 11.1 15.5939 11.1 16.0909C11.1 16.588 11.5029 16.9909 12 16.9909Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const CautionFilled = React.forwardRef(IconComponent);
CautionFilled.displayName = 'CautionFilled';

export { CautionFilled };
